import { IconSvg, IconSvgProps } from "./icon"

export default function MicrophoneMuted(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 17.46v2.73M12.408 15.254c-.394.044-3.684.226-3.684-3.8" />
      <path d="M14.278 16.98a5.678 5.678 0 0 1-2.278.48 5.358 5.358 0 0 1-5.46-5.227v-1.87M17.46 10.362v1.87a5.096 5.096 0 0 1-1.515 3.604M5.448 4.903l13.103 13.649M8.724 8.317v-1.23A3.268 3.268 0 0 1 12 3.81a3.269 3.269 0 0 1 3.276 3.275v4.368a4.033 4.033 0 0 1-.867 2.78" />
    </IconSvg>
  )
}
